module.exports = __webpack_public_path__ + "img/premium-slider-2.60c523cf.png";